import axios from "../../config/axiosConfig";
import {
  PURCHASE_INTREST_CALCULATION_REPORT_REQUEST,
  PURCHASE_INTREST_CALCULATION_REPORT_SUCCESS,
  PURCHASE_INTREST_CALCULATION_REPORT_FAILURE
} from "../types/purchase-intrest-calculation-report-types";

export const getPurchaseInterestCalculation = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_INTREST_CALCULATION_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      console.log('params', params);
      
      const requestParams = { ...defaultParams, ...params };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/outstanding-report/getPurchaseIntrestCalculationReport?${queryString}`;

      console.log('Complete API Request URL: ', fullUrl);

      return axios.get('/outstanding-report/getPurchaseIntrestCalculationReport', {
        params: requestParams,
      }).then((response) => {
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: PURCHASE_INTREST_CALCULATION_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Purchase Outstanding Report:", error);
        dispatch({ type: PURCHASE_INTREST_CALCULATION_REPORT_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching Purchase Outstanding Report:", error);
      dispatch({ type: PURCHASE_INTREST_CALCULATION_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearPurchaseInterestCalculation = () => {
  return async (dispatch) => {
    dispatch({ type: PURCHASE_INTREST_CALCULATION_REPORT_SUCCESS, payload: {} });
  }
}